export default __webpack_public_path__ + "static/media/7_1_1.9028bd97.png";